// import {createStore, applyMiddleware, compose} from 'redux';
// import thunkMiddleware from 'redux-thunk';
// import reducers from "./reducer";

// export function configureStore(initialState) {
//     //setup dev tools
//     const composeEnhancers =
//         typeof window === 'object' &&
//         window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
//             window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
//                 // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
//             }) : compose;

//     const enhancer = composeEnhancers(
//         applyMiddleware(
//             thunkMiddleware,
//             // loggerMiddlerWare
//         )
//     );


//     const store = createStore(
//         reducers,
//         initialState,
//         enhancer
//     );
//     //sagaMiddleware.run(sagas);
//     return store;
// }



import { createStore, applyMiddleware, compose } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk'; // Corrected import
import reducers from "./reducer";

export function configureStore(initialState) {
    // Setup dev tools
    const composeEnhancers =
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
            }) : compose;

    const enhancer = composeEnhancers(
        applyMiddleware(
            thunkMiddleware,
            // loggerMiddleware
        )
    );

    const store = createStore(
        reducers,
        initialState,
        enhancer
    );
    // sagaMiddleware.run(sagas);
    return store;
}